import _ from "lodash";
import moment from "moment";

import { USER_TYPE_ENTITY_MAPPING } from "Constants";
import { PARENT, STAFF } from "Constants/stringConstants";
import ACLStore from "lib/aclStore";
import { getChildrenQuery } from "modules/CommonQuery";
import {
  getChildrenQueryForStaff,
  getPlatformUserDetailsQuery,
} from "FamilyProfile/modules/FamilyProfileQueries";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import client from "lib/apolloClient/client";
import { removeChildForFamilyMemberMutation } from "./FamilyProfileMutations";

export const getChildrenQueryVariables = ({
  familyMemberId,
  user_type,
  organizationId,
  userId,
  includeInvitedStudents = false,
}) => {
  const familyMemberEntityType = _.get(
    USER_TYPE_ENTITY_MAPPING["parent"],
    "entityType",
    ""
  );

  let variables = {
    id: familyMemberId,
    type: familyMemberEntityType,
    includeInvitedStudents:
      includeInvitedStudents !== null ? includeInvitedStudents : undefined,
  };

  if (user_type === STAFF) {
    variables = {
      ...variables,
      organizationId: organizationId,
    };
  }

  return variables;
};

export const WIDGETS = {
  PERSONAL_INFORMATION: {
    id: "PERSONAL_INFORMATION",
  },
  CHILD_CONNECTED: {
    id: "CHILD_CONNECTED",
  },
};

export const WIDGET_TYPES_NODES = {
  family: [WIDGETS.PERSONAL_INFORMATION.id, WIDGETS.CHILD_CONNECTED.id],
};

export const canTeacherAccessFamilyProfile = () => {
  return ACLStore.can(getTeacherAccessingFamilyProfilePermission());
};

export const getTeacherAccessingFamilyProfilePermission = () => {
  return "TeacherPortal:FamilyProfile";
};

export const canParentAccessTheirProfile = ({ userType }) => {
  const familyPermission = "FamilyPortal:FamilyProfile";
  return userType === PARENT && ACLStore.can(familyPermission);
};

export const getChildrenRefetchQueries = ({ variables, userId, userType }) => {
  const query = _.isEqual(userType, PARENT)
    ? getChildrenQuery
    : getChildrenQueryForStaff;

  return [
    {
      query,
      variables,
    },
    {
      query,
      variables: {
        id: userId,
        type: "FAMILY_MEMBER",
      },
    },
    {
      query: getPlatformUserDetailsQuery,
      variables: {
        id: userId,
        type: "FAMILY_MEMBER",
      },
    },
  ];
};

export const isExpiredToken = inviteExpireTime => {
  if (!inviteExpireTime) return [true, null];

  const inviteTime = moment(inviteExpireTime);
  const currentTime = moment();

  const duration = moment.duration(inviteTime.diff(currentTime));
  const days = Math.ceil(duration.asDays());

  return [moment(inviteExpireTime) < moment(), days];
};

export const removeChildForFamilyMember = function ({
  childId,
  parentId,
  includeInvitedStudents = true,
  skipRefetch = false,
}) {
  return async function () {
    const portalType = "PLANNER";

    // Currently logged in user information
    const userInfo = getUserInfo({ portalType });
    const userId = _.get(userInfo, "id");
    const user_type = _.get(userInfo, "user_type");
    const organizationId = _.get(userInfo, "org_id");

    const query = _.isEqual(user_type, PARENT)
      ? getChildrenQuery
      : getChildrenQueryForStaff;

    const childrenQueryVariables = getChildrenQueryVariables({
      familyMemberId: parentId,
      user_type,
      organizationId,
      userId,
      includeInvitedStudents,
    });

    try {
      await client.mutate({
        mutation: removeChildForFamilyMemberMutation,
        variables: { studentId: childId, parentId },
        refetchQueries: !skipRefetch
          ? [
              {
                query,
                variables: childrenQueryVariables,
              },
            ]
          : [],
        awaitRefetchQueries: true,
      });
    } catch (e) {
      console.error(e);
    }
  };
};
